import { Field } from 'redux-form';
import styled from 'styled-components';
import { colors, MediaQuery } from '../../../theme/style-helpers';
import { P } from '../../../theme/typographySitecore';
import CheckmarkCircledGreen from '../../../assets/icons/CheckmarkCircledGreen.svg';
import FieldFileInput from '../FileUploadButton';

export const UploadDocumentsContainer = styled.div`
  background-color: ${colors.LIGHT_GREY};
  padding: 16px 32px;
`;

export const UploadDocumentsRowContainer = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

export const UploadDocumentsRow = styled.li`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${colors.COOL_GREY};
  padding: 12px 0;

  &:last-of-type {
    border: none;
  }
`;

export const RowLabel = styled(P)`
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;

export const UploadButton = styled(Field)`
  width: unset;
  border: none;

  &:hover {
    cursor: pointer;

    p {
      text-decoration: underline;
    }
  }

  label {
    color: ${colors.BLACK};
  }
`;

export const UploadButtonLabel = styled.p`
  margin-top: 0;
  margin-bottom: 0;
  font-size: 14px;
`;

export const ButtonsCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-end;
  flex: 1;
`;

export const FileNameContainer = styled.div`
  display: flex;
  padding: 10px 0;
  gap: 8px;
  
  ${MediaQuery.medium`
    flex-direction: row;
    padding-right: initial;
  `}
`;

export const CheckmarkIcon = styled.img.attrs(() => ({ src: CheckmarkCircledGreen }))`
`;

export const FileUploadLabel = styled.label`
    font-style: normal;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 2.2rem;
    color: ${colors.BLACK};
    margin: 0 8px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    
    ${MediaQuery.medium`
      margin-right: 8px;
      margin-bottom: 0;
      max-width: initial;
      white-space: initial;
      overflow: initial;
      text-overflow: initial;
    `}    
`;

export const FileInputField = styled(FieldFileInput)`
  padding: 0;

  div {
    padding: 0;
    
    label {
      max-width: 250px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  
  ${MediaQuery.medium`
    padding: initial;

    div {
      flex-direction: initial;
      padding: initial;
      
      label {      
        margin-left: initial;
        
        max-width: initial;
        white-space: initial;
        overflow: initial;
        text-overflow: initial;
      }
    }
  `}
`;
